<template>
    <div>
        <div ref="contentRef" :class="{'filter-list-scroll-container': contentIsScroll, 'fix-height': fixHeight}"
            class="inner-list-container">
            <template v-for="(item, index) of filterArr" :key="filterListKey(item)">
                <div class="filter-content-container">
                    <span class="condition-text">{{ index === 0 ? '当' : '且' }}</span>
                    <FilterItem class="filter-content"
                        :columnList="source"
                        :value="item"
                        :limitFieldSingle="limitFieldSingle"
                        :disableAll="disableAll"
                        :needLabel="needLabel"
                        :filterArr="filterArr"
                        @change="(value) => changeFilterValue(index, value)">
                    </FilterItem>
                    <span v-if="filterArr.length > minLength" class="del-icon fusion-iconfont icon-delete" @click="delItem(index)" :class="{'disable-event': disableAll}"></span>
                </div>
            </template>
        </div>
        <slot name="extra-foot"></slot>
        <span @click="addItem()" class="add-container" v-if="filterArr.length < computedMaxLength" :class="{'disable-event': disableAll}">
            <span class="add-icon">+</span>
            <span>{{ addText }}</span>
        </span>
        <slot name="extra-btns"></slot>
    </div>
</template>

<script lang="ts" setup name="filterList">
import { ref, watch, onMounted, onBeforeUnmount, computed, } from 'vue';
import FilterItem from './filterItem.vue'
import { addResizeListener, removeResizeListener } from '/@/utils/event';

const contentRef = ref(null);
const props = withDefaults(defineProps<{
    maxLength?: number,
    minLength?: number,
    source: Array<any>,
    value: Array<any>,
    disableAll?: boolean,
    addText?: string,
    needLabel?: boolean,
    maxConfigHeight?: number,
    fixHeight?: boolean,
    limitFieldSingle?: boolean, // 是否允许配置项重复
    viewId?: string,
    businessType: string,
}>(), {
    maxLength: 10, 
    minLength: 1,
    source: () => [],
    value: () => [],
    disableAll: false,
    addText: '添加筛选条件',
    needLabel: false,
    maxConfigHeight: 350,
    limitFieldSingle: false,
    viewId: undefined,
    businessType: 'fusionFilter'
});
const emit = defineEmits(['update:value', 'change', 'inited'])
const maxContentConfig = {
    height: `${props.maxConfigHeight}px`,
};
const contentIsScroll = ref(false);

// 如果设置配置项不允许重复，那配置项不能大于可以配置项的数量
const computedMaxLength = computed(() => {
    if (props.limitFieldSingle) {
        return Math.min(props.maxLength, props.source.length)
    }
    return props.maxLength;
})

const filterArr = ref([]);
watch(() => props.value, (value) => {
    const result = value || [];
    filterArr.value = result;

    try{
      if(!!value.find(d => d.columnName)){ 
        emit('inited', filterArr.value)
      }
    } catch (error) {
        console.log(error)
    }
}, {
    immediate: true,
})

function delItem(index) {
    if (props.disableAll) {
        return;
    }
    filterArr.value.splice(index, 1);
    emitValueChange();
}

function addItem() {
    if (props.disableAll) {
        return;
    }
    const currentId = filterArr.value[filterArr.value.length - 1]?.id || 0;
    // 新增优先添加没有被选中的字段，如果没有则添加第一个字段
    const newAddedItem = props.source?.find?.(item => !filterArr.value?.some(selectedItem => selectedItem.field === item.javaField))

    filterArr.value.push({
        field: newAddedItem?.javaField ?? props.source[0]?.javaField,
        id: currentId + 1,
    });
    emitValueChange();
    showLastRow();
}

async function showLastRow() {
    setTimeout(() => {
        const rowsEle: Element[] = contentRef.value.querySelectorAll('.filter-content');
        const lastRowEle: Element = [...rowsEle].at(-1);

        lastRowEle.scrollIntoView();
    })
    
}

function changeFilterValue(index, item) {
    filterArr.value[index] = item;
    emitValueChange();
}

function emitValueChange() {
    emit('update:value', filterArr.value)
    emit('change', filterArr.value)
}

/*
* filterList绑定key 用于render不同视图的filterItem
* @params  item
* @return Boolean 筛选器中添加视图viewId 用于切换视图重新render
* */
const filterListKey = (item) => {
  return props?.businessType === 'fusionFilter' && props?.viewId ? (item.id + props.viewId) : item.id
}

onMounted(() => {
    listenContentHeight();
})

onBeforeUnmount(() => {
    removeResizeListener(contentRef.value, contentHeightCallback)
})

function listenContentHeight() {
    addResizeListener(contentRef.value, contentHeightCallback)
}

function contentHeightCallback() {
    const height = getComputedStyle(contentRef.value).height;
    contentIsScroll.value = parseInt(height) >= parseInt(maxContentConfig.height)
}

</script>


<style lang="less" scoped>
@import url('../assets/icons/fusion-iconfont.css');

.filter-list-scroll-container {
    max-height: v-bind('maxContentConfig.height');
    overflow: auto;
    padding-right: 4px;
}
.fix-height {
    height: v-bind('maxContentConfig.height');
}
.disable-event {
    cursor: not-allowed!important;
    color: #bfbfbf!important;
}
.del-icon {
    cursor: pointer;
    color: #999;
    font-size: 14px;
    &:hover {
        color: #2c68ff;
    }
}
.inner-list-container {
    margin-bottom: 16px;
}
.add-container {
    cursor: pointer;
    color: #2c68ff;
    font-size: 14px;
    height: 20px;
    line-height: 20px;
}
.add-icon {
    margin-right: 8px;
    font-size: 18px;
}
.del-icon {
    margin-left: 8px;
}

.filter-content-container {
    display: flex;
    align-items: center;
    color: #333;
    margin-bottom: 8px;
    &:last-of-type {
        margin-bottom: 0;
    }

    .filter-content {
        flex: 1;
        width: 0;
    }
}
.condition-text {
    margin-right: 8px;
}
</style>
